export class AppConfigValueMissingError extends Error {
	public constructor(path: string) {
		super(`App config value "${path}" is missing.`);
		this.name = 'AppConfigValueMissingError';
	}
}
